import {Button, Col, Form, Row} from 'react-bootstrap'
import {TFormAllValues, TFormKeys} from '../policiesTypes'
import { FormikErrors, FormikTouched } from 'formik'

export const HouseholdInfoTab: React.FC<{
  onPrev: () => void
  onNext: () => void
  handleChange: (field: string, value: any) => void
  handleBlur: (field: TFormKeys) => void
  values: TFormAllValues
  errors: FormikErrors<TFormAllValues>
  touched: FormikTouched<TFormAllValues>
}> = ({onNext, onPrev, handleBlur, handleChange, values, errors, touched}) => {
  return (
    <>
      <div className='household-information'>
        <div className='title-section-policy-form'>
          <h6>Household information</h6>
        </div>
        <Row className='address-section-policy-form'>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Form.Group>
              <Form.Label>
                Number of applicants <small className='text-danger'>{errors.applicants}</small>
              </Form.Label>
              <Form.Control
                placeholder='Enter number of applicants'
                type='number'
                min='1'
                onChange={(e) => handleChange('applicants', e.target.value)}
                value={values.applicants}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Form.Group>
              <Form.Label>Number of members</Form.Label>
              <Form.Control
                type='number'
                placeholder='Enter number of members'
                onChange={(e) => handleChange('members', e.target.value)}
                value={values.members}
                required
              />
            </Form.Group>
          </Col>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Form.Group>
              <Form.Label>Estimated household income</Form.Label>
              <Form.Control
                type='text'
                placeholder='0,000'
                // onChange={(e) => handleChange('householdIncome', e.target.value)}
                value={values.holder.annualIncome1}
                onChange={(e) => {
                  const {value} = e.target
                  const noComma = value.replaceAll(',', '')
                  if (noComma !== '' && isNaN(Number(noComma))) return
                  const str = Intl.NumberFormat('en-US').format(Number(noComma))
                  handleChange('holder.annualIncome1', str)
                }}
                required
              />
            </Form.Group>
          </Col>
        </Row>
      </div>
     <div className='btn-prev-next'>
        <Button size='sm' variant='outline' onClick={onPrev} >
          PREVIOUS
        </Button>
        <Button size='sm' onClick={onNext}>NEXT STEP</Button>
      </div>
    </>
  )
}
